import React from 'react';
import { Select } from '@material-ui/core';

interface Props {
  value: luxon.DateTime,
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
  isUnselectedFlightHour: boolean
}

/** タクシー・ハイヤー予約画面の時刻のセレクトボックスのコンポーネント。 */
export const SelectFlightHour: React.FC<Props> = (props: Props) => {
  /** 「時」部分（1~23までの数値）の配列。 */
  const hours = Array.from(Array(24).keys());
  const defaultValue = props.isUnselectedFlightHour ? '---' : props.value?.hour;

  const setValue = (v: number) => {
    return v.toString().padStart(2, '0');
  }

  return (
    <Select native value={defaultValue} onChange={props.onChange}>
      {props.isUnselectedFlightHour && <option value='---'>---</option>}
      {
        hours.map((h) => {
          return <option value={h} key={`hours_${h}`}>{setValue(h)}</option>
        })
      }
    </Select>
  );
}

export default SelectFlightHour;
